/* eslint-disable jsx-a11y/label-has-for */
import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { setValue } from '../../../../store/actions';
import useComponent from '../../../../hooks/useComponent';
import { HELP, AI_INSTRUCTIONS } from './customHtmlPrompt';

const initialState = {
  data: {
    type: 'CustomHtml',
    code: '',
    fullWidth: true,
    heightMode: 'auto',
    height: null,
  },
  error: false,
};

const HEIGHT_MODES = ['auto', 'fixed', 'viewport'];

const CustomHtml = ({ components, handlerSetComponents, id }) => {
  const { state: { data }, dispatch } = useComponent({ components, id, initialState, setComponents: handlerSetComponents });
  const set = setValue(dispatch);
  const [helpOpen, setHelpOpen] = useState(false);
  const [copied, setCopied] = useState(false);

  const copyInstructions = () => {
    const done = () => { setCopied(true); setTimeout(() => setCopied(false), 1500); };
    if (navigator.clipboard && navigator.clipboard.writeText) {
      navigator.clipboard.writeText(AI_INSTRUCTIONS).then(done);
    } else {
      const ta = document.createElement('textarea');
      ta.value = AI_INSTRUCTIONS;
      document.body.appendChild(ta);
      ta.select();
      document.execCommand('copy');
      document.body.removeChild(ta);
      done();
    }
  };

  return (
    <div className="w-full">
      <div className="flex justify-between items-center mb-2">
        <div className="text-black font-semibold text-sm">Paste your HTML / JS code:</div>
        <div className="flex items-center">
          <button
            type="button"
            className="font-americaMonoRegular text-xs uppercase bg-greyFilterItems text-black rounded-full px-4 py-2 mr-2"
            onClick={() => setHelpOpen(!helpOpen)}
          >
            {helpOpen ? 'How it works ▲' : 'How it works ▼'}
          </button>
          <button
            type="button"
            className="font-americaMonoBold text-xs uppercase bg-blue-darker text-white rounded-full px-4 py-2"
            onClick={copyInstructions}
          >
            {copied ? '✓ Copied!' : 'Copy instructions for the AI'}
          </button>
        </div>
      </div>

      {helpOpen && (
        <div className="bg-greyFilterItems rounded-lg p-4 mb-3 text-sm text-black">
          <ol className="pl-4">
            {HELP.steps.map(step => <li key={step} className="mb-1">{step}</li>)}
          </ol>
          <ul className="pl-4 mt-2 border-t border-white pt-2">
            {HELP.notes.map(note => <li key={note} className="mb-1">{note}</li>)}
          </ul>
        </div>
      )}

      <textarea
        className="appearance-none block w-full bg-gray-200 text-gray-700 border rounded py-3 px-4 my-3 leading-tight focus:outline-none focus:bg-white font-americaMonoRegular text-xs"
        style={{ height: '250px' }}
        name="code"
        spellCheck="false"
        onChange={e => set('code', e.target.value)}
        value={data.code || ''}
      />

      <div className="w-full bg-greyFilter rounded-lg flex items-center py-2 px-4">
        <span className="font-americaMonoRegular text-xs uppercase text-black mr-2">Height:</span>
        {HEIGHT_MODES.map(mode => (
          <button
            key={mode}
            type="button"
            className={`font-americaMonoBold text-xs uppercase rounded-full px-3 py-1 mr-1 ${data.heightMode === mode ? 'bg-blue-darker text-white' : 'bg-white text-black'}`}
            onClick={() => set('heightMode', mode)}
          >
            {mode}
          </button>
        ))}
        {data.heightMode === 'fixed' && (
          <input
            className="font-americaMonoRegular bg-white outline-none rounded-full ml-2 p-2 w-24 text-xs"
            type="number"
            placeholder="px"
            value={data.height || ''}
            onChange={e => set('height', e.target.value ? parseInt(e.target.value, 10) : null)}
          />
        )}
        <div className="text-xs uppercase text-black font-americaMonoRegular flex items-center ml-auto">
          Full width
          <label className="switch mb-0 pb-0 h-6 ml-1">
            <input
              name="fullWidth"
              checked={!data.fullWidth}
              onChange={() => set('fullWidth', !data.fullWidth)}
              type="checkbox"
            />
            <div className="switch-slider btn-yn switch-round" />
          </label>
        </div>
      </div>
    </div>
  );
};

CustomHtml.propTypes = {
  components: PropTypes.arrayOf(PropTypes.shape()).isRequired,
  id: PropTypes.string.isRequired,
  handlerSetComponents: PropTypes.func.isRequired,
};

export default CustomHtml;
